module.exports = __webpack_public_path__ + "img/29passenger_parked.6a1b6697.svg";